const pageNameKey = "addNewMachineDrawerModal";

export const addNewMachineDrawerModalEn = {
  [pageNameKey]: {
    title: "Adding Machine (1/2)",
    sectionTitle: "Machine Onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Machine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway Connected to the Machine",
    gatewayPlaceholder: "Search gateways...",
    noGatewaysFound: "No gateways found",
    machineNameLabel: "Machine Name",
    hostOrIpAddressLabel: "Machine Primary Hostname/IP Address",
    help: "Help",
    machineNameHelpText:
      "You will find your machine by this name in Things OS.",
    ipAddressHelpText:
      "Enter the hostname or IP address that the gateway can use to access the machine over the network.",
    connectButton: "Connect",
    invalidIpAddressErrorMessage: "Please enter a valid hostname or IP address",
    continueMachineSkillsButton: "Continue to Machine Skills",
    titleStepTwo: "Adding Machine (2/2)",
    sectionTitleStepTwo: "Adding Machine Skills",
    machineSkillsDescription:
      "Machine detection identified the following machine skills: {skills}. Enable the required skills to complete the setup.",
    installAndFinishSetupButton: "Install And Finish Setup",
    finishSetupWithoutSkillsButton: "Finish Setup Without Machine Skills",
    machineIpReachable: "Machine hostname/IP reachable",
    checkingMachineAvailability: "Checking machine availability",
    skillsIdentified: "Skills identified",
    noMachineSkillsFoundMessage:
      "No machine skills automatically (e.g., OPC UA, VNC) found",
    opcUaNotIdentifiedErrorMessage:
      "OPC UA could not be automatically identified.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA is required. Configure the OPC UA skill before finishing the setup.",
    machineIpAddressMismatchErrorMessage: "Hostname/IP does not match",
    skillsNotAvailableErrorMessage: "Skills not available",
    operationPendingWarningMessage:
      "Connection state is still in IDLE or IN_PROGRESS - You might see the source appear in the list if the process is concluded successfully.",
    operationTimedOutErrorMessage: "The connection timed out.",
    operationFailureErrorMessage: "The connection failed.",
    operationBackendFailureErrorMessage:
      "A backend error occurred while checking the connection.",
    createMachineFailedErrorMessage: "Failed to create machine.",
    certificateGenerationFailedErrorMessage:
      "Failed to generate the certificate. Please try again.",
    skillInstallSuccessMessage: "Machine skills installed successfully",
    invalidPortErrorMessage: "Please enter a valid 2 to 5 digit port",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "This is the port the gateway uses to access the machine's RPC server for Things Twin Data.",
    invalidRpcDsnErrorMessage: "Please enter a valid DSN address",
    showProtocol: "Show Protocol",
    hideProtocol: "Hide Protocol",
    getSupport: "Get Support",
    statusIconAltText: "Status icon",
    opcUaErrorDetailsTitle: "OPC UA error details",
    titleSummary: "Adding Machine (Summary)",
    sectionTitleSummary: "Machine Onboarding Summary",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Installed skills",
    summaryFailedSkillsLabel: "Failed skills",
    summarySkippedSkillsLabel: "Skipped skills",
    summaryFinishButton: "Add Another Machine",
    summaryGoToNewMachineButton: "Go to New Machine",
    summaryRetryButton: "Retry",
    summaryStatusSuccess: "Setup completed",
    summaryStatusPartialSuccess: "Setup completed with some failures",
    summaryStatusFailed: "Setup failed",
    summaryStatusSkipped: "Setup completed without machine skills",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "This is the port the gateway uses to access the machine's VNC server for HMI screen sharing.",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "This is the port the gateway uses to access the machine's OPC UA server for Things Twin Data.",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Adicionando máquina (1/2)",
    sectionTitle: "Integração da máquina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Máquina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway conectado à máquina",
    gatewayPlaceholder: "Buscar gateways...",
    noGatewaysFound: "Nenhum gateway encontrado",
    machineNameLabel: "Nome da máquina",
    hostOrIpAddressLabel: "Endereço principal de hostname/IP da máquina",
    help: "Ajuda",
    machineNameHelpText:
      "Você encontrará sua máquina por esse nome no Things OS.",
    ipAddressHelpText:
      "Insira o hostname ou endereço IP que o gateway pode usar para acessar a máquina pela rede.",
    connectButton: "Conectar",
    invalidIpAddressErrorMessage: "Insira um hostname ou endereço IP válido",
    continueMachineSkillsButton: "Continuar para habilidades da maquina",
    titleStepTwo: "Adicionando máquina (2/2)",
    sectionTitleStepTwo: "Habilidades da máquina (2/2)",
    machineSkillsDescription:
      "A detecção da máquina identificou as seguintes habilidades: {skills}. Ative as habilidades necessárias para concluir a configuração.",
    installAndFinishSetupButton: "Instalar e concluir configuracao",
    finishSetupWithoutSkillsButton: "Concluir sem habilidades da maquina",
    machineIpReachable: "Hostname/IP da maquina acessivel",
    checkingMachineAvailability: "Verificando a disponibilidade da máquina",
    skillsIdentified: "Habilidades identificadas",
    noMachineSkillsFoundMessage:
      "Nenhuma habilidade de máquina (por exemplo, OPC UA, VNC) encontrada automaticamente",
    opcUaNotIdentifiedErrorMessage:
      "Não foi possível identificar o OPC UA automaticamente.",
    opcUaSkillRequiredErrorMessage:
      "O OPC UA é obrigatório. Configure a habilidade OPC UA antes de concluir a configuração.",
    machineIpAddressMismatchErrorMessage: "Hostname/IP nao corresponde",
    skillsNotAvailableErrorMessage: "Habilidades nao disponiveis",
    operationPendingWarningMessage:
      "O estado da conexao ainda e IDLE ou IN_PROGRESS - A origem pode aparecer na lista se o processo for concluido com sucesso.",
    operationTimedOutErrorMessage: "A conexao expirou.",
    operationFailureErrorMessage: "A conexao falhou.",
    operationBackendFailureErrorMessage:
      "Ocorreu um erro de backend ao verificar a conexao.",
    createMachineFailedErrorMessage: "Falha ao criar a maquina.",
    certificateGenerationFailedErrorMessage:
      "Falha ao gerar o certificado. Tente novamente.",
    skillInstallSuccessMessage: "Habilidades da maquina instaladas com sucesso",
    invalidPortErrorMessage: "Insira uma porta valida entre 1 e 65535",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor RPC da máquina para os dados do Things Twin.",
    invalidRpcDsnErrorMessage: "Insira um endereco DSN valido",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obter suporte",
    statusIconAltText: "Icone de status",
    opcUaErrorDetailsTitle: "Detalhes do erro OPC UA",
    titleSummary: "Adicionando máquina (Resumo)",
    sectionTitleSummary: "Resumo da configuração da máquina",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Habilidades instaladas",
    summaryFailedSkillsLabel: "Habilidades com falha",
    summarySkippedSkillsLabel: "Habilidades ignoradas",
    summaryFinishButton: "Adicionar outra máquina",
    summaryGoToNewMachineButton: "Ir para a nova máquina",
    summaryRetryButton: "Tentar novamente",
    summaryStatusSuccess: "Configuração concluída",
    summaryStatusPartialSuccess: "Configuração concluída com falhas",
    summaryStatusFailed: "Configuração falhou",
    summaryStatusSkipped: "Configuração sem habilidades da máquina",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor VNC da máquina para compartilhamento de tela HMI.",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor OPC UA da máquina para os dados do Things Twin.",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalDe = {
  [pageNameKey]: {
    title: "Maschine hinzufügen (1/2)",
    sectionTitle: "Maschinen-Onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Maschine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Mit der Maschine verbundenes Gateway",
    gatewayPlaceholder: "Gateways suchen...",
    noGatewaysFound: "Keine Gateways gefunden",
    machineNameLabel: "Maschinenname",
    hostOrIpAddressLabel: "Primäre Hostname/IP-Adresse der Maschine",
    help: "Hilfe",
    machineNameHelpText:
      "Sie finden Ihre Maschine unter diesem Namen in Things OS.",
    ipAddressHelpText:
      "Geben Sie den Hostnamen oder die IP-Adresse ein, die das Gateway verwenden kann, um über das Netzwerk auf die Maschine zuzugreifen.",
    connectButton: "Verbinden",
    invalidIpAddressErrorMessage:
      "Bitte geben Sie einen gültigen Hostnamen oder eine gültige IP-Adresse ein",
    continueMachineSkillsButton: "Weiter zu Maschinen-Skills",
    titleStepTwo: "Maschine hinzufügen (2/2)",
    sectionTitleStepTwo: "Maschinen-Skills (2/2)",
    machineSkillsDescription:
      "Die Maschinenerkennung hat die folgenden Maschinen-Skills identifiziert: {skills}. Aktivieren Sie die erforderlichen Skills, um das Setup abzuschließen.",
    installAndFinishSetupButton: "Installieren und Setup abschliessen",
    finishSetupWithoutSkillsButton: "Setup ohne Maschinen-Skills beenden",
    machineIpReachable: "Maschinen-Hostname/IP erreichbar",
    checkingMachineAvailability: "Maschinenverfügbarkeit wird geprüft",
    skillsIdentified: "Skills erkannt",
    noMachineSkillsFoundMessage:
      "Keine Maschinen-Skills (z. B. OPC UA, VNC) automatisch gefunden",
    opcUaNotIdentifiedErrorMessage:
      "OPC UA konnte nicht automatisch identifiziert werden.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA ist erforderlich. Konfigurieren Sie den OPC-UA-Skill, bevor Sie das Setup abschließen.",
    machineIpAddressMismatchErrorMessage: "Hostname/IP stimmt nicht ueberein",
    skillsNotAvailableErrorMessage: "Skills nicht verfuegbar",
    operationPendingWarningMessage:
      "Der Verbindungsstatus ist noch IDLE oder IN_PROGRESS - Die Quelle kann in der Liste erscheinen, wenn der Vorgang erfolgreich abgeschlossen wird.",
    operationTimedOutErrorMessage: "Die Verbindung ist abgelaufen.",
    operationFailureErrorMessage: "Die Verbindung ist fehlgeschlagen.",
    operationBackendFailureErrorMessage:
      "Beim Pruefen der Verbindung ist ein Backend-Fehler aufgetreten.",
    createMachineFailedErrorMessage: "Maschine konnte nicht erstellt werden.",
    certificateGenerationFailedErrorMessage:
      "Das Zertifikat konnte nicht erzeugt werden. Bitte versuchen Sie es erneut.",
    skillInstallSuccessMessage: "Maschinen-Skills erfolgreich installiert",
    invalidPortErrorMessage:
      "Bitte geben Sie einen gueltigen Port zwischen 1 und 65535 ein",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den RPC-Server der Maschine für Things-Twin-Daten zuzugreifen.",
    invalidRpcDsnErrorMessage: "Bitte geben Sie eine gueltige DSN-Adresse ein",
    showProtocol: "Protokoll anzeigen",
    hideProtocol: "Protokoll ausblenden",
    getSupport: "Support erhalten",
    statusIconAltText: "Statussymbol",
    opcUaErrorDetailsTitle: "OPC-UA-Fehlerdetails",
    titleSummary: "Maschine hinzufügen (Zusammenfassung)",
    sectionTitleSummary: "Maschinen-Setup Zusammenfassung",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Installierte Skills",
    summaryFailedSkillsLabel: "Fehlgeschlagene Skills",
    summarySkippedSkillsLabel: "Übersprungene Skills",
    summaryFinishButton: "Weitere Maschine hinzufügen",
    summaryGoToNewMachineButton: "Zur neuen Maschine",
    summaryRetryButton: "Erneut versuchen",
    summaryStatusSuccess: "Setup abgeschlossen",
    summaryStatusPartialSuccess: "Setup mit einigen Fehlern abgeschlossen",
    summaryStatusFailed: "Setup fehlgeschlagen",
    summaryStatusSkipped: "Setup ohne Maschinen-Skills abgeschlossen",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den VNC-Server der Maschine für die HMI-Bildschirmfreigabe zuzugreifen.",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den OPC-UA-Server der Maschine für Things-Twin-Daten zuzugreifen.",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalZhHans = {
  [pageNameKey]: {
    title: "添加机器 (1/2)",
    sectionTitle: "机器上线 (1/2)",
    stepGateway: "网关",
    stepMachine: "机器",
    stepThingsOs: "Things OS",
    gatewayLabel: "连接到机器的网关",
    gatewayPlaceholder: "搜索网关...",
    noGatewaysFound: "未找到网关",
    machineNameLabel: "机器名称",
    hostOrIpAddressLabel: "机器主机名/IP地址",
    help: "帮助",
    machineNameHelpText: "您将在 Things OS 中通过此名称找到您的机器。",
    ipAddressHelpText: "输入网关可用于通过网络访问机器的主机名或 IP 地址。",
    connectButton: "连接",
    invalidIpAddressErrorMessage: "请输入有效的主机名或IP地址",
    continueMachineSkillsButton: "继续到机器技能",
    titleStepTwo: "添加机器 (2/2)",
    sectionTitleStepTwo: "机器技能 (2/2)",
    machineSkillsDescription:
      "机器检测识别出以下机器技能：{skills}。启用所需技能以完成设置。",
    installAndFinishSetupButton: "安装并完成设置",
    finishSetupWithoutSkillsButton: "不安装机器技能并完成设置",
    machineIpReachable: "机器主机名/IP可达",
    checkingMachineAvailability: "正在检查机器可用性",
    skillsIdentified: "已识别技能",
    noMachineSkillsFoundMessage: "未自动找到机器技能（例如 OPC UA、VNC）",
    opcUaNotIdentifiedErrorMessage: "无法自动识别 OPC UA。",
    opcUaSkillRequiredErrorMessage:
      "OPC UA 为必填项。请在完成设置前配置 OPC UA 技能。",
    machineIpAddressMismatchErrorMessage: "主机名/IP不匹配",
    skillsNotAvailableErrorMessage: "技能不可用",
    operationPendingWarningMessage:
      "连接状态仍为 IDLE 或 IN_PROGRESS - 如果流程成功完成，源可能会出现在列表中。",
    operationTimedOutErrorMessage: "连接已超时。",
    operationFailureErrorMessage: "连接失败。",
    operationBackendFailureErrorMessage: "检查连接时发生后端错误。",
    createMachineFailedErrorMessage: "创建机器失败。",
    certificateGenerationFailedErrorMessage: "证书生成失败，请重试。",
    skillInstallSuccessMessage: "机器技能安装成功",
    invalidPortErrorMessage: "请输入1到65535之间的有效端口",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "这是网关用于访问机器的 RPC 服务器以获取 Things Twin 数据的端口。",
    invalidRpcDsnErrorMessage: "请输入有效的DSN地址",
    showProtocol: "显示协议",
    hideProtocol: "隐藏协议",
    getSupport: "获取支持",
    statusIconAltText: "状态图标",
    opcUaErrorDetailsTitle: "OPC UA 错误详情",
    titleSummary: "添加机器 (摘要)",
    sectionTitleSummary: "机器设置摘要",
    summaryStatusLabel: "状态",
    summaryInstalledSkillsLabel: "已安装技能",
    summaryFailedSkillsLabel: "失败技能",
    summarySkippedSkillsLabel: "已跳过技能",
    summaryFinishButton: "添加另一台机器",
    summaryGoToNewMachineButton: "转到新机器",
    summaryRetryButton: "重试",
    summaryStatusSuccess: "设置完成",
    summaryStatusPartialSuccess: "设置完成但有部分失败",
    summaryStatusFailed: "设置失败",
    summaryStatusSkipped: "未安装机器技能，设置完成",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "这是网关用于访问机器的 VNC 服务器以进行 HMI 屏幕共享的端口。",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "这是网关用于访问机器的 OPC UA 服务器以获取 Things Twin 数据的端口。",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalIt = {
  [pageNameKey]: {
    title: "Aggiunta macchina (1/2)",
    sectionTitle: "Onboarding macchina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Macchina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway collegato alla macchina",
    gatewayPlaceholder: "Cerca gateway...",
    noGatewaysFound: "Nessun gateway trovato",
    machineNameLabel: "Nome macchina",
    hostOrIpAddressLabel: "Indirizzo hostname/IP primario della macchina",
    help: "Aiuto",
    machineNameHelpText:
      "Troverai la tua macchina con questo nome in Things OS.",
    ipAddressHelpText:
      "Inserisci l'hostname o l'indirizzo IP che il gateway può utilizzare per accedere alla macchina tramite la rete.",
    connectButton: "Connetti",
    invalidIpAddressErrorMessage: "Inserisci un hostname o indirizzo IP valido",
    continueMachineSkillsButton: "Continua alle skill della macchina",
    titleStepTwo: "Aggiunta macchina (2/2)",
    sectionTitleStepTwo: "Skill macchina (2/2)",
    machineSkillsDescription:
      "Il rilevamento della macchina ha identificato le seguenti skill: {skills}. Abilita le skill necessarie per completare la configurazione.",
    installAndFinishSetupButton: "Installa e completa configurazione",
    finishSetupWithoutSkillsButton: "Completa senza skill macchina",
    machineIpReachable: "Hostname/IP macchina raggiungibile",
    checkingMachineAvailability: "Verifica della disponibilità della macchina",
    skillsIdentified: "Skill identificate",
    noMachineSkillsFoundMessage:
      "Nessuna skill macchina (ad es. OPC UA, VNC) trovata automaticamente",
    opcUaNotIdentifiedErrorMessage:
      "Impossibile identificare automaticamente OPC UA.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA è obbligatorio. Configura la skill OPC UA prima di completare la configurazione.",
    machineIpAddressMismatchErrorMessage: "L'hostname/IP non corrisponde",
    skillsNotAvailableErrorMessage: "Skill non disponibili",
    operationPendingWarningMessage:
      "Lo stato della connessione e ancora IDLE o IN_PROGRESS - L'origine potrebbe comparire nell'elenco se il processo viene completato correttamente.",
    operationTimedOutErrorMessage: "Connessione scaduta.",
    operationFailureErrorMessage: "Connessione non riuscita.",
    operationBackendFailureErrorMessage:
      "Si e verificato un errore backend durante il controllo della connessione.",
    createMachineFailedErrorMessage: "Creazione della macchina non riuscita.",
    certificateGenerationFailedErrorMessage:
      "Generazione del certificato non riuscita. Riprova.",
    skillInstallSuccessMessage: "Skill macchina installate con successo",
    invalidPortErrorMessage: "Inserisci una porta valida tra 1 e 65535",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server RPC della macchina per i dati di Things Twin.",
    invalidRpcDsnErrorMessage: "Inserisci un indirizzo DSN valido",
    showProtocol: "Mostra protocollo",
    hideProtocol: "Nascondi protocollo",
    getSupport: "Ottieni supporto",
    statusIconAltText: "Icona di stato",
    opcUaErrorDetailsTitle: "Dettagli errore OPC UA",
    titleSummary: "Aggiunta macchina (Riepilogo)",
    sectionTitleSummary: "Riepilogo configurazione macchina",
    summaryStatusLabel: "Stato",
    summaryInstalledSkillsLabel: "Skill installate",
    summaryFailedSkillsLabel: "Skill non riuscite",
    summarySkippedSkillsLabel: "Skill saltate",
    summaryFinishButton: "Aggiungi un'altra macchina",
    summaryGoToNewMachineButton: "Vai alla nuova macchina",
    summaryRetryButton: "Riprova",
    summaryStatusSuccess: "Configurazione completata",
    summaryStatusPartialSuccess: "Configurazione completata con alcuni errori",
    summaryStatusFailed: "Configurazione fallita",
    summaryStatusSkipped: "Configurazione completata senza skill",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server VNC della macchina per la condivisione dello schermo HMI.",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server OPC UA della macchina per i dati di Things Twin.",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalEs = {
  [pageNameKey]: {
    title: "Agregando máquina (1/2)",
    sectionTitle: "Incorporación de la máquina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Máquina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway conectado a la máquina",
    gatewayPlaceholder: "Buscar gateways...",
    noGatewaysFound: "No se encontraron gateways",
    machineNameLabel: "Nombre de la máquina",
    hostOrIpAddressLabel: "Dirección principal de hostname/IP de la máquina",
    help: "Ayuda",
    machineNameHelpText: "Encontrará su máquina con este nombre en Things OS.",
    ipAddressHelpText:
      "Introduce el hostname o la dirección IP que el gateway puede utilizar para acceder a la máquina a través de la red.",
    connectButton: "Conectar",
    invalidIpAddressErrorMessage: "Introduce un hostname o dirección IP válida",
    continueMachineSkillsButton: "Continuar a habilidades de la maquina",
    titleStepTwo: "Agregando máquina (2/2)",
    sectionTitleStepTwo: "Habilidades de la máquina (2/2)",
    machineSkillsDescription:
      "La detección de la máquina identificó las siguientes habilidades: {skills}. Habilite las habilidades necesarias para completar la configuración.",
    installAndFinishSetupButton: "Instalar y finalizar configuracion",
    finishSetupWithoutSkillsButton: "Finalizar sin habilidades de maquina",
    machineIpReachable: "Hostname/IP de la maquina alcanzable",
    checkingMachineAvailability: "Comprobando la disponibilidad de la máquina",
    skillsIdentified: "Habilidades identificadas",
    noMachineSkillsFoundMessage:
      "No se encontraron habilidades de máquina automáticamente (por ejemplo, OPC UA, VNC)",
    opcUaNotIdentifiedErrorMessage:
      "No se pudo identificar OPC UA automáticamente.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA es obligatorio. Configure la habilidad OPC UA antes de finalizar la configuración.",
    machineIpAddressMismatchErrorMessage: "El hostname/IP no coincide",
    skillsNotAvailableErrorMessage: "Habilidades no disponibles",
    operationPendingWarningMessage:
      "El estado de la conexion sigue en IDLE o IN_PROGRESS - El origen podria aparecer en la lista si el proceso finaliza correctamente.",
    operationTimedOutErrorMessage: "La conexion ha expirado.",
    operationFailureErrorMessage: "La conexion ha fallado.",
    operationBackendFailureErrorMessage:
      "Se produjo un error de backend al comprobar la conexion.",
    createMachineFailedErrorMessage: "Error al crear la maquina.",
    certificateGenerationFailedErrorMessage:
      "Error al generar el certificado. Intentelo de nuevo.",
    skillInstallSuccessMessage: "Habilidades de maquina instaladas con exito",
    invalidPortErrorMessage: "Introduce un puerto valido entre 1 y 65535",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor RPC de la máquina para los datos de Things Twin.",
    invalidRpcDsnErrorMessage: "Introduce una direccion DSN valida",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obtener soporte",
    statusIconAltText: "Icono de estado",
    opcUaErrorDetailsTitle: "Detalles del error OPC UA",
    titleSummary: "Agregando máquina (Resumen)",
    sectionTitleSummary: "Resumen de configuración de la máquina",
    summaryStatusLabel: "Estado",
    summaryInstalledSkillsLabel: "Habilidades instaladas",
    summaryFailedSkillsLabel: "Habilidades fallidas",
    summarySkippedSkillsLabel: "Habilidades omitidas",
    summaryFinishButton: "Agregar otra máquina",
    summaryGoToNewMachineButton: "Ir a la nueva máquina",
    summaryRetryButton: "Reintentar",
    summaryStatusSuccess: "Configuración completada",
    summaryStatusPartialSuccess: "Configuración completada con algunos fallos",
    summaryStatusFailed: "Configuración fallida",
    summaryStatusSkipped: "Configuración completada sin habilidades de máquina",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC Port",
    vncPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor VNC de la máquina para compartir la pantalla HMI.",
    portSettingsLabel: "Port Settings",
    portIsAvailableLabel: "Port is available",
    opcUaPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor OPC UA de la máquina para los datos de Things Twin.",
    securityModeLabel: "Security Mode",
    securityPolicyLabel: "Security Policy",
    authenticationTabsLabel: "Authentication",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    clientCertificateTab: "Client Certificate",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalNl = {
  [pageNameKey]: {
    title: "Machine toevoegen (1/2)",
    sectionTitle: "Machine-onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Machine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway verbonden met de machine",
    gatewayPlaceholder: "Zoek gateways...",
    noGatewaysFound: "Geen gateways gevonden",
    machineNameLabel: "Machinenaam",
    hostOrIpAddressLabel: "Primair hostname/IP-adres van machine",
    help: "Help",
    machineNameHelpText: "U vindt uw machine onder deze naam in Things OS.",
    ipAddressHelpText:
      "Voer de hostnaam of het IP-adres in dat de gateway kan gebruiken om via het netwerk toegang te krijgen tot de machine.",
    connectButton: "Verbinden",
    invalidIpAddressErrorMessage: "Voer een geldige hostnaam of IP-adres in",
    continueMachineSkillsButton: "Doorgaan naar machine-skills",
    titleStepTwo: "Machine toevoegen (2/2)",
    sectionTitleStepTwo: "Machine-skills toevoegen",
    machineSkillsDescription:
      "De machinedetectie heeft de volgende machine-skills geïdentificeerd: {skills}. Schakel de vereiste skills in om de configuratie te voltooien.",
    installAndFinishSetupButton: "Installeren en configuratie afronden",
    finishSetupWithoutSkillsButton:
      "Configuratie afronden zonder machine-skills",
    machineIpReachable: "Machine-hostname/IP bereikbaar",
    checkingMachineAvailability: "Beschikbaarheid van machine controleren",
    skillsIdentified: "Skills gedetecteerd",
    noMachineSkillsFoundMessage:
      "Geen machine-skills (bijv. OPC UA, VNC) automatisch gevonden",
    opcUaNotIdentifiedErrorMessage:
      "OPC UA kon niet automatisch worden geïdentificeerd.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA is verplicht. Configureer de OPC UA-skill voordat u de configuratie afrondt.",
    machineIpAddressMismatchErrorMessage: "Hostname/IP-adres komt niet overeen",
    skillsNotAvailableErrorMessage: "Skills niet beschikbaar",
    operationPendingWarningMessage:
      "De verbindingsstatus is nog IDLE of IN_PROGRESS - De bron kan in de lijst verschijnen als het proces succesvol wordt afgerond.",
    operationTimedOutErrorMessage: "De verbinding is verlopen.",
    operationFailureErrorMessage: "De verbinding is mislukt.",
    operationBackendFailureErrorMessage:
      "Er is een backendfout opgetreden bij het controleren van de verbinding.",
    createMachineFailedErrorMessage: "Machine aanmaken is mislukt.",
    certificateGenerationFailedErrorMessage:
      "Het certificaat kon niet worden gegenereerd. Probeer het opnieuw.",
    skillInstallSuccessMessage: "Machine-skills succesvol geïnstalleerd",
    invalidPortErrorMessage: "Voer een geldige poort met 2 tot 5 cijfers in",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de RPC-server van de machine voor Things Twin-gegevens.",
    invalidRpcDsnErrorMessage: "Voer een geldig DSN-adres in",
    showProtocol: "Protocol tonen",
    hideProtocol: "Protocol verbergen",
    getSupport: "Ondersteuning krijgen",
    statusIconAltText: "Statuspictogram",
    opcUaErrorDetailsTitle: "OPC UA-foutdetails",
    titleSummary: "Machine toevoegen (Samenvatting)",
    sectionTitleSummary: "Samenvatting machine-onboarding",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Geïnstalleerde skills",
    summaryFailedSkillsLabel: "Mislukte skills",
    summarySkippedSkillsLabel: "Overgeslagen skills",
    summaryFinishButton: "Nog een machine toevoegen",
    summaryGoToNewMachineButton: "Ga naar de nieuwe machine",
    summaryRetryButton: "Opnieuw proberen",
    summaryStatusSuccess: "Configuratie voltooid",
    summaryStatusPartialSuccess: "Configuratie voltooid met enkele fouten",
    summaryStatusFailed: "Configuratie mislukt",
    summaryStatusSkipped: "Configuratie voltooid zonder machine-skills",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Deze machine-skill biedt gebruikers de mogelijkheid om de HMI van een machine op afstand veilig te bekijken en te bedienen, alsof ze er zelf bij zijn.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "De Digital Twin maakt een virtuele representatie van de machine die continu wordt gesynchroniseerd met live data om prestaties te monitoren, analyseren en optimaliseren.",
    readMoreLabel: "Meer lezen",
    readLessLabel: "Minder lezen",
    opcUaRequiredTooltip:
      "This skill is required to complete the onboarding of your machine.",
    vncPortLabel: "VNC-poort",
    vncPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de VNC-server van de machine voor HMI-scherm delen.",
    portSettingsLabel: "Poortinstellingen",
    portIsAvailableLabel: "Poort is beschikbaar",
    opcUaPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de OPC UA-server van de machine voor Things Twin-gegevens.",
    securityModeLabel: "Beveiligingsmodus",
    securityPolicyLabel: "Beveiligingsbeleid",
    authenticationTabsLabel: "Authenticatie",
    usernameLabel: "Gebruikersnaam",
    passwordLabel: "Wachtwoord",
    clientCertificateLabel: "Clientcertificaat (Base64)",
    clientCertificatePrivateKeyLabel: "Private key clientcertificaat (Base64)",
    clientCertificatePasswordLabel: "Wachtwoord clientcertificaat",
    serverPublicKeyLabel: "Openbare serversleutel",
    anonymousTab: "Anoniem",
    userLoginTab: "Gebruikerslogin",
    clientCertificateTab: "Clientcertificaat",
    pleaseFixFieldsLabel: "Corrigeer de volgende velden",
  },
};

export const addNewMachineDrawerModalTr = {
  [pageNameKey]: {
    title: "Ekleme Makinası (1/2)",
    sectionTitle: "Makineye Ekleme (1/2)",
    stepGateway: "Geçit",
    stepMachine: "Makine",
    stepThingsOs: "Şeyler İşletim Sistemi",
    gatewayLabel: "Makineye Bağlı Ağ Geçidi",
    gatewayPlaceholder: "Ağ geçitlerini ara...",
    noGatewaysFound: "Ağ geçidi bulunamadı",
    machineNameLabel: "Makine Adı",
    hostOrIpAddressLabel: "Makine Birincil Ana Bilgisayar Adı/IP Adresi",
    help: "Yardım",
    machineNameHelpText: "Makinenizi Things OS'ta bu isimle bulacaksınız.",
    ipAddressHelpText:
      "Ağ geçidinin ağ üzerinden makineye erişmek için kullanabileceği ana bilgisayar adını veya IP adresini girin.",
    connectButton: "Bağlamak",
    invalidIpAddressErrorMessage:
      "Lütfen geçerli bir ana bilgisayar adı veya IP adresi girin",
    continueMachineSkillsButton: "Makine Becerilerine Devam Et",
    titleStepTwo: "Ekleme Makinası (2/2)",
    sectionTitleStepTwo: "Makine Becerileri Ekleme",
    machineSkillsDescription:
      "Makine algılaması şu makine becerilerini tanımladı: {skills}. Kurulumu tamamlamak için gerekli becerileri etkinleştirin.",
    installAndFinishSetupButton: "Kurulumu Yükleyin ve Bitirin",
    finishSetupWithoutSkillsButton:
      "Kurulumu Makine Becerileri Olmadan Bitirin",
    machineIpReachable: "Makine ana bilgisayar adı/IP'ye erişilebilir",
    checkingMachineAvailability: "Makine kullanılabilirliğini kontrol etme",
    skillsIdentified: "Tanımlanan beceriler",
    noMachineSkillsFoundMessage:
      "Otomatik olarak hiçbir makine becerisi bulunamadı (ör. OPC UA, VNC)",
    opcUaNotIdentifiedErrorMessage: "OPC UA otomatik olarak tanımlanamadı.",
    opcUaSkillRequiredErrorMessage:
      "OPC UA gereklidir. Kurulumu tamamlamadan önce OPC UA becerisini yapılandırın.",
    machineIpAddressMismatchErrorMessage: "Ana makine adı/IP eşleşmiyor",
    skillsNotAvailableErrorMessage: "Beceriler mevcut değil",
    operationPendingWarningMessage:
      "Bağlantı durumu hala IDLE veya IN_PROGRESS durumunda - İşlem başarıyla tamamlanırsa kaynağın listede göründüğünü görebilirsiniz.",
    operationTimedOutErrorMessage: "Bağlantı zaman aşımına uğradı.",
    operationFailureErrorMessage: "Bağlantı başarısız oldu.",
    operationBackendFailureErrorMessage:
      "Bağlantı kontrol edilirken bir arka uç hatası oluştu.",
    createMachineFailedErrorMessage: "Makine oluşturulamadı.",
    certificateGenerationFailedErrorMessage:
      "Sertifika oluşturulamadı. Lütfen tekrar deneyin.",
    skillInstallSuccessMessage: "Makine becerileri başarıyla yüklendi",
    invalidPortErrorMessage:
      "Lütfen 2 ila 5 haneli geçerli bir bağlantı noktası girin",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Bu, ağ geçidinin, Things Twin Data için makinenin RPC sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    invalidRpcDsnErrorMessage: "Lütfen geçerli bir DSN adresi girin",
    showProtocol: "Protokolü Göster",
    hideProtocol: "Protokolü Gizle",
    getSupport: "Destek Alın",
    statusIconAltText: "Durum simgesi",
    opcUaErrorDetailsTitle: "OPC UA hata ayrıntıları",
    titleSummary: "Ekleme Makinesi (Özet)",
    sectionTitleSummary: "Makineye Ekleme Özeti",
    summaryStatusLabel: "Durum",
    summaryInstalledSkillsLabel: "Yüklü beceriler",
    summaryFailedSkillsLabel: "Başarısız beceriler",
    summarySkippedSkillsLabel: "Atlanan beceriler",
    summaryFinishButton: "Başka Bir Makine Ekle",
    summaryGoToNewMachineButton: "Yeni Makineye Git",
    summaryRetryButton: "Yeniden dene",
    summaryStatusSuccess: "Kurulum tamamlandı",
    summaryStatusPartialSuccess: "Kurulum bazı hatalarla tamamlandı",
    summaryStatusFailed: "Kurulum başarısız oldu",
    summaryStatusSkipped: "Kurulum makine becerileri olmadan tamamlandı",
    thingsSupportTitle: "Şeyler Desteği",
    thingsSupportDescription:
      "Bu makine becerisi, kullanıcılara bir makinenin insan-makine arayüzünü sanki oradaymış gibi gerçek zamanlı olarak uzaktan, güvenli bir şekilde görüntüleme ve kontrol etme olanağı sağlar.",
    thingsTwinTitle: "Şeyler İkiz",
    thingsTwinDescription:
      "Dijital İkiz, performansı izlemek, analiz etmek ve optimize etmek için makinenin canlı verilerle sürekli olarak senkronize edilen sanal bir temsilini oluşturur.",
    readMoreLabel: "Devamını oku",
    readLessLabel: "Daha az oku",
    opcUaRequiredTooltip:
      "Bu beceri, makinenizin eklenmesini tamamlamak için gereklidir.",
    vncPortLabel: "VNC Bağlantı Noktası",
    vncPortHelpText:
      "Bu, ağ geçidinin HMI ekran paylaşımı için makinenin VNC sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    portSettingsLabel: "Bağlantı Noktası Ayarları",
    portIsAvailableLabel: "Bağlantı noktası mevcut",
    opcUaPortHelpText:
      "Bu, ağ geçidinin, Things Twin Data için makinenin OPC UA sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    securityModeLabel: "Güvenlik Modu",
    securityPolicyLabel: "Güvenlik Politikası",
    authenticationTabsLabel: "Kimlik doğrulama",
    usernameLabel: "Kullanıcı adı",
    passwordLabel: "Şifre",
    clientCertificateLabel: "İstemci Sertifikası (Base64)",
    clientCertificatePrivateKeyLabel:
      "İstemci Sertifikası Özel Anahtarı (Base64)",
    clientCertificatePasswordLabel: "İstemci Sertifikası Şifresi",
    serverPublicKeyLabel: "Sunucu Genel Anahtarı",
    anonymousTab: "Anonim",
    userLoginTab: "Kullanıcı Girişi",
    clientCertificateTab: "Müşteri Sertifikası",
    pleaseFixFieldsLabel: "Lütfen aşağıdaki alanları düzeltin",
  },
};
